import { DataTable } from '@/components/data-table/data-table';
import { DataTableFilterMenu } from '@/components/data-table/data-table-filter-menu';
import { DataTableSortList } from '@/components/data-table/data-table-sort-list';
import { DataTableViewOptions } from '@/components/data-table/data-table-view-options';
import { usePurchaseOrdersTable } from '@/features/purchase-orders/hooks/use-purchase-orders-table';
import { cn } from '@/lib/utils';

type PurchaseOrdersTableProps = {
  onPurchaseOrderClick: (purchaseOrderId: string) => void;
};

export function PurchaseOrdersTable({
  onPurchaseOrderClick,
}: PurchaseOrdersTableProps) {
  const { table, isPending } = usePurchaseOrdersTable();

  return (
    <div
      className={cn(
        'relative flex min-h-0 flex-1 flex-col',
        isPending && 'pointer-events-none',
      )}
    >
      {isPending && (
        <div className='absolute inset-0 z-20 animate-pulse rounded-md bg-muted/40' />
      )}
      <DataTable
        className={cn('min-h-0', isPending && 'opacity-60')}
        onRowClick={(row) => onPurchaseOrderClick(row.original.id)}
        table={table}
      >
        <div
          className='flex w-full items-start justify-between gap-2 p-1'
          role='toolbar'
        >
          <div className='flex flex-1 flex-wrap items-center gap-2'>
            <DataTableFilterMenu table={table} />
            <DataTableSortList table={table} />
          </div>
          <div className='flex items-center gap-2'>
            <DataTableViewOptions align='end' table={table} />
          </div>
        </div>
      </DataTable>
    </div>
  );
}
